module.exports = __webpack_public_path__ + "img/gh_photo2@2x.22868e33.png";